import Icon from "./icon.js";

const { redom } = window;
const { el } = redom;

export default class Fly {
  constructor({ app, api, i18n }) {
    this.api = api;
    this.el = el(
      ".fly",
      (this.button = el("#fly-button", (this.icon = new Icon("pencil-pin"))))
    );
    this.button.onclick = () => {
      api.resubmitPlan = null;
      if (api.menuOpened) {
        api.menuOpened = false;
        api.menuSection = "";
      }
      if (!api.drawPlan) {
        const { marker } = api.app.map;

        if (marker) {
          const { lng, lat } = marker.getLngLat();

          api.currentDrawing = [{ lng, lat }];
        } else {
          api.currentDrawing = [];
        }
      } else {
        api.currentDrawing = [];
      }

      api.drawPlan = !api.drawPlan;
      api.update();
    };
  }

  update() {
    const { DISABLE_OPERATION_PLANS, ENABLE_AIRSPACE_RESERVATION } = window.ENV;

    if (!DISABLE_OPERATION_PLANS && !ENABLE_AIRSPACE_RESERVATION) {
      this.icon.update("drone");
    }

    this.opened = this.api.drawPlan;
  }
}
